export default "__VITE_ASSET__51c57e8f__"